<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：项目信息v-loading="loading"
  -->
  <div class="pb50">
    <div class="product-content"  v-if="detail">
      <!--商品信息-->
      <div class="common-form mt16">项目信息</div>
      <div class="table-wrap">
        <el-table size="small" :data="detail.product" border style="width: 100%">
          <el-table-column prop="productName" label="项目名称"></el-table-column>
          <el-table-column prop="totalPrice" label="价格">
            <template slot-scope="scope">
              <div class="red">￥ {{scope.row.totalPrice?scope.row.totalPrice:0.00}} 元</div>
            </template>
          </el-table-column>
          <el-table-column prop="isClock" label="是否加钟" min-width="100">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="info">
                  <div v-if="scope.row.isClock==1" class="price">是</div>
                  <div v-else class="name">否</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="serviceTime" label="服务时长（分钟)"></el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <!-- filePath -->
        </el-table>
      </div>

    </div>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import { deepClone } from "@/utils/base.js";
export default {
 inject: ["detail"],
  data() {
    return {
      /*是否加载完成*/
      loading: true
      /*订单数据*/
      // detail: {
      //   product: []
      // }
    };
  },
  created(e) {
    console.log(this.detail)
    /*获取列表*/
    // this.getParams();
  },
  methods: {
    /*获取参数*/
    getParams() {
      let self = this;
      // 取到路由带过来的参数
      const params = this.$route.query.orderId;
      OrderApi.orderdetail(
        {
          orderId: params
        },
        true
      )
        .then(data => {
          self.loading = false;
          self.detail = data.data.detail;
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/order/order/part/project.vue